import { isServerSide } from "@jti/fe-common/utils";

export enum XSellingDialogEvents {
  open = "xselling-dialog-open",
  close = "xselling-dialog-close",
}

export type XSellingDialogEventDetail = {
  skus?: string[];
};

export const dispatchXSellingDialogEvent = <EventName extends XSellingDialogEvents>(
  eventName: EventName,
  detail?: XSellingDialogEventDetail
) => {
  if (isServerSide()) {
    return Promise.resolve();
  }
  const event = new CustomEvent<XSellingDialogEventDetail>(eventName, { detail });
  window.dispatchEvent(event);
  return new Promise((resolve) => setTimeout(resolve, 500));
};
